*, ::before, ::after {
	box-sizing: border-box;
	color: inherit;
	font-family: inherit;
	overflow-wrap: break-word;
}

@mixin visually-hidden {
	position: absolute     !important;
	height: 1px            !important;
	width:  1px            !important;
	white-space: nowrap    !important;
	overflow: hidden       !important;
	clip-path: inset(100%) !important;
	border: 0              !important;
	padding: 0             !important;
	margin: 0              !important;
	outline: none          !important;
}
.visually-hidden:not(:focus-visible) {
	@include visually-hidden;
}

[hidden] {
	display: none !important;
}

:disabled, .disabled {
	pointer-events: none;
	cursor: not-allowed;
	opacity: 0.8;
	filter: grayscale(0.4);
}

button {
	appearance: none;
	background: none;
	padding: 0;
	border: none;
	margin: 0;
	line-height: 1;
	text-decoration: none;
	cursor: pointer;
}

:host {
	display: flow-root;
}

:host(:not([open])) {
	slot:is(
		[name='close-label'],
		[name='close-icon']
	) {
		display: none;
	}
}
:host([open]) {
	slot:is(
		[name='open-label'],
		[name='open-icon']
	) {
		display: none;
	}
}

#summary {
	display: flex;
	align-items: center;
	gap: 1em;
}

:host(.mobile-menu) {
	#content {
		transition: all 350ms;
		margin-top:-100px;
		width: 100vw;
		min-height: 100vh;
		background: #fff;
		overflow-y: scroll;
	}

	.content-closed {
		transform: translateX(-100vw);
	}
	
	.content-open {
		transform: translateX(0);
	}
}

@include media-breakpoint-up(lg) {
	:host(.nav-parent) {
		.content-closed {
			display: none !important;
		}

		.close-nav-parent {
			display: none;
		}
	}
}

@include media-breakpoint-down(lg) {
	:host(.nav-parent) {
		#content {
			position: absolute;
			top: 0;
			left: 0;
			transition: all 350ms;
			width: 100vw;
			height: 100vh;
			overflow-y: auto;
			background: linear-gradient(to top, #f1f1f1 50%, $white);
			padding-bottom: 2rem;
		}
	
		.content-closed {
			transform: translateX(-100vw);
		}
		
		.content-open {
			transform: translateX(0);
		}

		.close-nav-parent {
			position: relative;
			padding: 23px 24px 24px 24px;
			cursor: pointer;
			app-icon { cursor: pointer; }
			app-icon > svg {
				width: 15px;
				height: 11px;
			}
			&::before {
				content: '';
				inset: 0;
				position: absolute;
				z-index: 1; 
			}
		}
	}
}

:host([interest-toggle].hide-toggle) {
	@media (hover: hover) {
		#toggle:not(:focus-visible) {
			@include visually-hidden;
		}
	}
}

:host([name="menu-level-1"]) {
	slot:is([name='toggle']) {
		column-gap: 4px;
		display: flex;
	}
}

:host(.disclaimer) {
	#summary {
		border-bottom: thin solid red;
		flex-direction: row-reverse;
		justify-content: start;
		margin-bottom:  rem(16);
		padding-bottom: rem(16);
	}

	#toggle {
		background-color: $primary;
		border-radius: $border-radius-sm;
		color: white;
		max-height: rem(24);
		min-height: rem(24);
		max-width:  rem(24);
		min-width:  rem(24);

		&:is(:hover, :focus-visible) {
			background-color: green;
		}
	}
}